<template>
  <div class="row justify-content-center align-items-center">
    <div class="col-12 spinner-border" role="status">
      <span class="visually-hidden">Chargement ...</span>
    </div>
  </div>
</template>